import {
  Box,
  Stack,
  Alert,
  Dialog,
  Button,
  IconButton,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';

type Props = {
  title: string;
  error: any;
  open: boolean;
  onClose: VoidFunction;
};
export function DialogError({ title, error, open, onClose, ...other }: Props) {
  const { t } = useTranslation();
  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose} {...other}>
      <DialogTitle variant="h4" sx={{ px: 4, pb: 2 }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ pb: 1 }}>
          <Box>{t(title)}</Box>
          <IconButton aria-label="close" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent dividers sx={{ px: 4, pt: 1, pb: 0, border: 'none' }}>
        <DialogContentText>
          <Alert variant="filled" severity="error">
            {t(error?.message)}.
          </Alert>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onClose}>
          {t('Close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
